define('datakit/lib/abstract.belongs.to.many.relationship.type',['require','exports','module','underscore','backbone','./belongs.to.relationship.type'],function(require, exports, module) {
  var _                         = require('underscore');
  var Backbone                  = require('backbone');
  var BelongsToRelationshipType = require('./belongs.to.relationship.type');


  var AbstractBelongsToManyRelationshipType = BelongsToRelationshipType.extend({
    supportedResourceClass: Backbone.Collection,
    configureResource: function() {
      // overriden with empty function since the `BelongsToRelationshipType`
      // implements its own configureResource
    }
  });

  module.exports = AbstractBelongsToManyRelationshipType;
});
